import { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import useFetch from '../../../../components/hooks/useFetch';
import { useNavigate } from 'react-router-dom';
import './TelaEndereco.scss';
import CardEndereco from './CardEndereco.js';
import ModalDialog from '../../../../components/modal/ModalDialog.js';
import FormExcluirEndereco from './FormExcluirEndereco.js';
import { AuthContext } from '../../../../store/AuthContext';
import {
  ENDERECOS_PESQUISA,
  ENDERECOS_TORNAR_PRINCIPAL,
} from '../../../../services/endereco';
import { getIPAddress } from '../../../../components/utils/GetIPAddress';
import { abreAlertaDialog } from '../../../../components/modal/AlertaDialog';

const TelaEndereco = () => {
  const { t } = useTranslation();
  const [modalAbertoExcluir, setModalAbertoExcluir] = useState(false);
  const [enderecoSelecionado, setEnderecoSelecionado] = useState();
  const { request: requestPrincipal } = useFetch();
  const navigate = useNavigate();
  const [alterei, setAlterei] = useState(false);
  const { request: requestEnderecos, data: dadosEnderecos } = useFetch();
  const [ipAddress, setIpAddress] = useState('');
  useEffect(() => {
    const fetchIPAddress = async () => {
      const ip = await getIPAddress();
      const port = window.location.port;
      setIpAddress(ip + ':' + port);
    };
    fetchIPAddress();
  }, []);

  const { user } = useContext(AuthContext);
  let idCorreios = user?.sub;

  const chamaPrincipal = () => {
    navigate('/principal');
  };

  const chamaNovoEndereco = () => {
    const dados = [idCorreios, ipAddress];
    navigate('/novoEndereco', { state: dados });
  };

  const chamaAlterarEndereco = (item) => {
    const dados = [item, idCorreios, ipAddress];
    navigate('/alterarEndereco', { state: dados });
  };

  const abreModalExcluir = (item) => {
    setEnderecoSelecionado(item);
    setModalAbertoExcluir(true);
  };

  const fechar = () => {
    setAlterei(true);
    setModalAbertoExcluir(false);
  };
  useEffect(() => {
    if (idCorreios && idCorreios != '')
      requestEnderecos(ENDERECOS_PESQUISA(idCorreios));
    else navigate('/login');
    setAlterei(false);
  }, [alterei]);

  const tornaPrincipal = async (item) => {
    const { response } = await requestPrincipal(
      ENDERECOS_TORNAR_PRINCIPAL(idCorreios, item.idEndereco),
    );
    setAlterei(false);
    if (response.ok) {
      abreAlertaDialog(t('principal.addresses.messages.main_address_changed'));
      setAlterei(true);
    }
  };

  return (
    <>
      <div className="conteudo enderecos">
        <h1 className="titulo-endereco">{t('principal.addresses.title')}</h1>
        <div className="cards-container">
          {dadosEnderecos?.map((item) => (
            <CardEndereco
              item={item}
              key={item.idEndereco}
              abreModalExcluir={abreModalExcluir}
              chamaAlterarEndereco={chamaAlterarEndereco}
              tornaPrincipal={tornaPrincipal}
            />
          ))}

          <button
            id="btn-adicionar-endereco"
            className="card-adicionar bg-superficie-var"
            onClick={() => chamaNovoEndereco()}
          >
            <i className="ic-adicionar-circulo"></i>
            {t('principal.addresses.add_address')}
          </button>
        </div>

        <button className="btn-pre" onClick={() => chamaPrincipal()}>
          {t('principal.forms.buttons.back')}
        </button>
      </div>

      <ModalDialog
        //titulo={nomeEndereco}
        id="modal-excluir"
        aberto={modalAbertoExcluir}
        setAberto={setModalAbertoExcluir}
        opcaoFechar={true}
      >
        <FormExcluirEndereco
          acaoCancelar={() => setModalAbertoExcluir(false)}
          acaoFechar={fechar}
          idCorreios={idCorreios}
          enderecoSelecionado={enderecoSelecionado}
          enderecos={dadosEnderecos}
        />
      </ModalDialog>
    </>
  );
};

export default TelaEndereco;
